import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import InlineLoading from "../../../../../components/Loading/Loading";
import MonthlyProfitAndLoss from "../../../../../models/financials/MonthlyProfitAndLoss";
import { primary } from "../../../../../assets/colorPallet";

function MonthlyProfitAndLossEbitda({ currentCompanyMonthlyProfitAndLoss }) {
  if (!(currentCompanyMonthlyProfitAndLoss instanceof MonthlyProfitAndLoss)) {
    return <InlineLoading />;
  }

  return (
    <div className="pb-10">
      <div className="flex items-center w-full mt-10">
        <div
          style={{ backgroundColor: primary }}
          className="absolute left-0 w-full h-12 bg-gradient-to-r from-transparent z-10 pointer-events-none"
        ></div>
        <div className="z-20" style={{ minWidth: "20em" }}></div>
        {currentCompanyMonthlyProfitAndLoss?.datesFormatted?.map((date) => (
          <div className="z-20 w-40 font-semibold" style={{ minWidth: "10em" }}>
            <label className="text-white">{date}</label>
          </div>
        ))}
      </div>
      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "20em" }}
        >
          <label>Interest</label>
        </div>
        <div className="flex pt-4">
          {currentCompanyMonthlyProfitAndLoss?.totalInterestExpense?.map(
            (item) => (
              <div className="flex items-center" style={{ minWidth: "10em" }}>
                <label>
                  {CurrencyFormatter.format(item?.value, { code: "USD" })}
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "20em" }}
        >
          <label>Taxes</label>
        </div>
        <div className="flex pt-4">
          {currentCompanyMonthlyProfitAndLoss?.totalIncomeTax?.map((item) => (
            <div className="flex items-center" style={{ minWidth: "10em" }}>
              <label>
                {CurrencyFormatter.format(item?.value, { code: "USD" })}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center pt-4"
          style={{ minWidth: "20em" }}
        >
          <label>Depreciation, Depletion, Amortization</label>
        </div>
        <div className="flex pt-4">
          {currentCompanyMonthlyProfitAndLoss?.totalDepreciationDepletionAndAmortization?.map(
            (item) => (
              <div className="flex items-center" style={{ minWidth: "10em" }}>
                <label>
                  {CurrencyFormatter.format(item?.value, { code: "USD" })}
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="flex items-center pt-4">
        <div
          className="whitespace-nowrap flex items-center border-t pt-4"
          style={{ minWidth: "20em" }}
        >
          <label className="font-semibold">Total Definition Adjustments</label>
        </div>
        <div className="flex pt-4 border-t">
          {currentCompanyMonthlyProfitAndLoss?.totalDefinitionAdjustments?.map(
            (item) => (
              <div className="flex items-center" style={{ minWidth: "10em" }}>
                <label className="font-semibold">
                  {CurrencyFormatter.format(item?.value, { code: "USD" })}
                </label>
              </div>
            )
          )}
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">EBITDA as Defined</label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyMonthlyProfitAndLoss?.EBITDAAsDefined?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="font-semibold">
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">EBITDA Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.EBITDAAsDefinedMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label className="text-xs">
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center border-t pt-4"
            style={{ minWidth: "20em" }}
          >
            <label className="font-semibold">EBITDA LTM</label>
          </div>
          <div className="flex pt-4 border-t">
            {currentCompanyMonthlyProfitAndLoss?.EBITDALastTwelveMonth?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label
                    className={
                      item.disabled == true //check disabled status to disable the earliest 12 months
                        ? "disabled font-semibold"
                        : "font-semibold"
                    }
                  >
                    {CurrencyFormatter.format(item?.value, { code: "USD" })}
                  </label>
                </div>
              )
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div
            className="whitespace-nowrap flex items-center pt-1"
            style={{ minWidth: "20em" }}
          >
            <label className="text-xs">EBITDA LTM Margin</label>
          </div>
          <div className="flex pt-1">
            {currentCompanyMonthlyProfitAndLoss?.EBITDALastTwelveMonthMargins?.map(
              (item) => (
                <div className="flex items-center" style={{ minWidth: "10em" }}>
                  <label
                    className={
                      item.disabled == true ? "disabled text-xs" : "text-xs"
                    }
                  >
                    {CurrencyFormatter.format(item?.value, { code: "" })}%
                  </label>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanyMonthlyProfitAndLoss:
    state.financials.currentCompanyMonthlyProfitAndLoss,
});

export default connect(mapStateToProps)(MonthlyProfitAndLossEbitda);
